import { useState } from 'react';
import {
    ActiveButton,
    BackButton,
    BorderDiv,
    TextGrid,
    TopText,
} from '../users/style';

import back_arrow from '../../common/images/back_arrow.svg';
import { useNavigate, useParams } from 'react-router-dom';
import { Col } from 'react-bootstrap';
import { Status } from '../trade/style';
import { colors, Loader } from '../../common/component';
import {
    useGetSingleSharesRequestQuery,
    useUpdateSharesRequestMutation,
} from '../../store/loanRequestApi';
import styled from 'styled-components';
import { ReactComponent as PdfIcon } from '../../common/images/pdf_icon.svg';
import {
    getAdminId,
    showErrorToast,
    showSuccessToast,
} from '../../common/utils';
import { Checkbox } from 'antd';
import moment from 'moment';
import { LoanApprovalModal } from '../../common/component/Ui/loanApproval';

export const ViewLoanRequest = () => {
    const param = useParams();
    const requestId = param?.id as string;
    const navigate = useNavigate();
    const adminId = getAdminId();
    const [isRejectLoading, setIsRejectLoading] = useState<boolean>(false);
    const [isApproveLoading, setIsApproveLoading] = useState<boolean>(false);
    const [disabled, setDisabled] = useState<boolean>(false);
    const { data: contentData, isLoading } =
        useGetSingleSharesRequestQuery(requestId);
    const [updateSharesRequest] = useUpdateSharesRequestMutation();

    const handleSharesRequestStatus = (status: string) => {
        if (status === 'rejected') {
            setIsRejectLoading(true);
        } else if (status === 'approved') {
            setIsApproveLoading(true);
        }
        let payload = {
            sharesRequestId: requestId,
            requestStatus: status,
            authorizedBy: adminId,
        };

        updateSharesRequest(payload)
            .unwrap()
            .then((result) => {
                navigate('/dashboard/loan-request');
                showSuccessToast(result?.message);
                if (status === 'rejected') {
                    setIsRejectLoading(false);
                } else if (status === 'approved') {
                    setIsApproveLoading(false);
                }
            })
            .catch((error) => {
                showErrorToast(error?.data?.message);
            });
    };

    return (
        <div className="pb-4">
            <div className="d-flex align-items-center my-2">
                <BackButton onClick={() => navigate(-1)}>
                    <img src={back_arrow} alt="" /> Back
                </BackButton>
                <TopText>
                    {' '}
                    <span>/Loan Request</span> / View Loan Request info
                </TopText>
            </div>
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    <BorderDiv className=" my-4 ">
                        <Col sm={8}>
                            <TextGrid>
                                <ActiveButton>Loan Request info</ActiveButton>
                            </TextGrid>
                        </Col>
                        <Col className="d-flex align-items-center justify-content-end mb-2 mb-sm-0">
                            <Status>
                                {contentData?.data?.status === 'active' ? (
                                    <p style={{ color: '#34a853' }}>Active</p>
                                ) : (
                                    <p style={{ color: 'red' }}>InActive</p>
                                )}
                            </Status>
                        </Col>
                    </BorderDiv>

                    <Container>
                        <Header>
                            <Wrap>
                                <Text>Loan Application</Text>
                                <Date>
                                    Date Submitted:{' '}
                                    {moment(
                                        contentData?.data?.createdAt,
                                    ).format('DD MM YYYY')}
                                </Date>
                            </Wrap>
                        </Header>
                        <CardOne>
                            <Title>Loan Request Information</Title>
                            <SubTitle>
                                Please double check the information below
                            </SubTitle>
                            <Content>
                                <Div>
                                    <Item>
                                        Account Name <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {contentData?.data?.accountName}
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Account Number <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {contentData?.data?.accountNumber}
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Bank Name <Span>*</Span>
                                    </Item>
                                    <Data>{contentData?.data?.bankName}</Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Interest Rate <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {contentData?.data?.interestRate}%
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Amount <Span>*</Span>
                                    </Item>
                                    <Data>
                                        ₦
                                        {contentData?.data?.amount.toLocaleString()}
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Amount Per Unit <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {contentData?.data?.amountPerUnit.toLocaleString()}
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Total Loan Unit <Span>*</Span>
                                    </Item>
                                    <Data>
                                        {contentData?.data?.shareAmountRequested?.toLocaleString()}
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Loan Deadline<Span>*</Span>
                                    </Item>
                                    <Data>
                                        {moment(
                                            contentData?.data?.sharesDeadline,
                                        ).format('DD MM YYYY HH:MM A')}
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Loan Purpose<Span>*</Span>
                                    </Item>
                                    <Data>
                                        {contentData?.data?.sharePurpose}
                                    </Data>
                                </Div>
                                <Div>
                                    <Item>
                                        Repayment Term<Span>*</Span>
                                    </Item>
                                    <Data>
                                        {contentData?.data?.repaymentTerm}
                                    </Data>
                                </Div>
                                <Cover>
                                    <Item>
                                        Collateral Document<Span>*</Span>
                                    </Item>
                                    <PdfIcon />
                                    <Anchor
                                        target="_blank"
                                        href={
                                            contentData?.data
                                                ?.collateralDocument
                                        }
                                    >
                                        <Pdf>
                                            {
                                                contentData?.data
                                                    ?.collateralDocument
                                            }
                                        </Pdf>
                                    </Anchor>
                                </Cover>
                                <Cover>
                                    <Item>
                                        Credit History Details<Span>*</Span>
                                    </Item>
                                    <PdfIcon />
                                    <Anchor
                                        target="_blank"
                                        href={
                                            contentData?.data
                                                ?.creditHistoryDetails
                                        }
                                    >
                                        <Pdf>
                                            {
                                                contentData?.data
                                                    ?.creditHistoryDetails
                                            }
                                        </Pdf>
                                    </Anchor>
                                </Cover>
                                <Cover>
                                    <Item>
                                        Additional Documentation<Span>*</Span>
                                    </Item>
                                    <PdfIcon />
                                    <Anchor
                                        target="_blank"
                                        href={
                                            contentData?.data
                                                ?.additionalDocumentation
                                        }
                                    >
                                        <Pdf>
                                            {
                                                contentData?.data
                                                    ?.additionalDocumentation
                                            }
                                        </Pdf>
                                    </Anchor>
                                </Cover>
                            </Content>
                        </CardOne>
                        {/* <CardOne>
                            <Title style={{ cursor: 'pointer' }}>
                                License Agreement
                            </Title>
                            <SubTitle>
                                Please agree to the following terms before
                                submitting.
                            </SubTitle>
                            <Content>
                                <Div>
                                    <ItemAgree>
                                        By checking the box to the right, you
                                        acknowledge that you have read the
                                        documents and licensing agreement,
                                        understand it, and agree to be bound by
                                        its terms and conditions.
                                    </ItemAgree>
                                </Div>
                            </Content>
                            <Checkbox
                                style={{
                                    width: '100%',
                                    color: '#7041de',
                                }}
                                onChange={(e) => setDisabled(e.target.checked)}
                            >
                                Agree to terms and conditions
                            </Checkbox>
                        </CardOne> */}
                        <BigButtonWrap>
                            <BigButtonOne
                                onClick={() =>
                                    handleSharesRequestStatus('rejected')
                                }
                            >
                                {!isRejectLoading ? 'Reject' : 'Loading...'}
                            </BigButtonOne>
                            <BigButtonTwo
                                onClick={() => {
                                    handleSharesRequestStatus('approved');
                                }}
                            >
                                {!isApproveLoading ? 'Approve' : 'Loading...'}
                            </BigButtonTwo>
                        </BigButtonWrap>
                    </Container>
                </>
            )}
        </div>
    );
};

const Container = styled.div``;

const Header = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 600px) {
        flex-direction: column;
        gap: 20px;
        align-items: flex-start;
        justify-content: flex-start;
    }
`;
const Wrap = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 40px;
    @media (max-width: 600px) {
        flex-direction: column;
        gap: 10px;
    }
`;
const ButtonWrap = styled.div`
    display: flex;
    gap: 10px;
`;
const Text = styled.div`
    font-weight: 500;
    @media (max-width: 600px) {
        text-align: start;
        margin-right: 13px;
    }
`;
const P = styled.p`
    color: #7041de;
    font-size: 14px;
    font-weight: 400;
`;

const Date = styled.p`
    font-size: 14px;
`;
const ButtonOne = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${colors.red};
    color: #fff;
    width: 80px;
    border: none;
    font-size: 14px;
    padding: 6px 50px;
    border-radius: 4px;
`;
const ButtonTwo = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    background: #7041de;
    color: #fff;
    width: 80px;
    border: none;
    font-size: 14px;
    padding: 6px 50px;
    border-radius: 4px;
    text-align: center;
`;

const CardOne = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 40px;
    background: #f8f8f8;
    color: #4d4d4d;
    padding: 20px 15px;
    border-radius: 10px;
    @media (max-width: 600px) {
        margin-top: 30px;
    }
`;

const Title = styled.div`
    color: #7041de;
`;

const SubTitle = styled.div`
    background: #f8f8f;
    font-size: 13px;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: start;
`;

const Div = styled.div`
    display: flex;
    flex-direction: row;
    gap: 40px;
    font-size: 14px;
    border-bottom: 1px solid #a1a1a1;
    width: 100%;
    padding: 15px 0px;
    cursor: pointer;
`;
const Cover = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    font-size: 14px;
    border-bottom: 1px solid #a1a1a1;
    width: 100%;
    padding: 15px 0px;
    cursor: pointer;
    @media (max-width: 600px) {
        overflow: auto;
    }
`;

const Item = styled.div`
    color: #4d4d4d;
`;

const ItemAgree = styled.div`
    color: #4d4d4d;
    width: 70%;
`;

const Span = styled.span`
    color: #7041de;
`;
const Data = styled.div`
    color: #121212;
    font-size: 14px;
    font-weight: 500;
`;

const Pdf = styled.div`
    color: #7041de;
    font-size: 15px;
    font-weight: 400;
    cursor: pointer;
`;
const Anchor = styled.a`
    text-underline: none;
    text-decoration: none;
`;
const BigButtonWrap = styled.div`
    display: flex;
    gap: 10px;
    width: 100%;
    margin: 40px 0px 10px 0px;
`;

const BigButtonOne = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${colors.red};
    color: #fff;
    width: 80px;
    border: none;
    font-size: 14px;
    padding: 10px 50px;
    border-radius: 4px;
    width: 100%;

    &:disabled {
        background: #ccc;
        cursor: not-allowed;
    }
`;
const BigButtonTwo = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    background: #7041de;
    color: #fff;
    width: 80px;
    border: none;
    font-size: 14px;
    padding: 10px 50px;
    border-radius: 4px;
    text-align: center;
    width: 100%;

    &:disabled {
        background: #ccc;
        cursor: not-allowed;
    }
`;
